import { AdminLoginInput, AdminMfaEnrol, AdminMfaInput, AdminTokens } from './schemas.js';
export const adminAuthRoutes = {
    login: {
        method: 'POST',
        path: '/admin/auth/login',
        body: AdminLoginInput,
        response: AdminTokens,
    },
    mfaEnrol: { method: 'POST', path: '/admin/auth/mfa/enrol', response: AdminMfaEnrol },
    mfaVerify: {
        method: 'POST',
        path: '/admin/auth/mfa/verify',
        body: AdminMfaInput,
        response: AdminTokens,
    },
};
//# sourceMappingURL=routes.js.map